// extracted by mini-css-extract-plugin
export default {"tagList":"MerchantPage_tagList__yafhS","tag":"MerchantPage_tag__tA5LN","contactInfo":"MerchantPage_contactInfo__CQOA-","infoItem":"MerchantPage_infoItem__676Xa"};